import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Connects to data-controller="persistent-tabs"
export default class extends Controller {
  connect() {
    this.element.addEventListener("shown.bs.tab", this.saveState.bind(this))
    this.restoreState()
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.saveState.bind(this))
  }

  restoreState() {
    let hash = window.location.hash
    const storageKey = this.getStorageKey()

    // 1. Priority: URL Hash (Deep linking)
    // 2. Fallback: LocalStorage (Persistence after redirect/reload without hash)
    if (!hash && storageKey) {
      const savedSelector = localStorage.getItem(storageKey)
      if (savedSelector) {
        hash = savedSelector
        // Update URL to match state
        history.replaceState(null, null, hash)
      }
    }

    if (hash) {
      // Ensure hash is safe/valid before querying
      try {
        const triggerEl = this.element.querySelector(`[data-bs-target="${hash}"], [href="${hash}"]`)
        if (triggerEl) {
          const tab = new bootstrap.Tab(triggerEl)
          tab.show()
        }
      } catch (e) {
        // Ignore invalid selectors/hashes
        // console.warn("Invalid tab selector:", hash)
      }
    }
  }

  saveState(event) {
    const triggerEl = event.target
    const targetSelector = triggerEl.getAttribute("data-bs-target") || triggerEl.getAttribute("href")

    if (targetSelector) {
      // Update URL
      history.replaceState(null, null, targetSelector)

      // Save to LocalStorage
      const storageKey = this.getStorageKey()
      if (storageKey) {
        localStorage.setItem(storageKey, targetSelector)
      }
    }
  }

  getStorageKey() {
    // Unique key per page path (e.g., 'active_tab:/courses/1/edit')
    return `active_tab:${window.location.pathname}`
  }
}
